var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container cardVisualizar" },
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("informacoes-conversa", {
              attrs: {
                idConversa: _vm.idConversa,
                voltar: "central/comunicacao"
              },
              on: { statusChanged: _vm.setStatus }
            }),
            _vm.statusConversa && _vm.statusConversa === "RESPONDIDA"
              ? _c("el-row", { staticClass: "footer-buttons" }, [
                  _c(
                    "div",
                    { staticClass: "responder" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-conversa",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.responder()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fal fa-reply" }),
                          _vm._v(" Responder")
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "finalizar-conversa" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-conversa",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.finalizar()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fal fa-check" }),
                          _vm._v(" Finalizar conversa")
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-row",
        { staticClass: "voltar-container" },
        [
          _c("app-buttons-cadastro", {
            attrs: {
              isPrimeiroPasso: false,
              isUltimoPasso: true,
              showButtonFinalizar: false,
              showButtonEnviar: false,
              showButtonCancelar: false
            },
            on: { voltar: _vm.voltar }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-183009b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-183009b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/comunicacao/VisualizarConversa.vue
// module id = null
// module chunks = 